import {
  EnhancedHeaderInputTypes,
  EnhancedTableHeader,
  EnhancedTableHeaderType
} from '@components/table/widgets/shared-with-old';

export const getAmendmentEndorsementCertificatesHeaders: (
  currency: string,
  disabled: boolean
) => Record<string, EnhancedTableHeader> = (
  currency: string,
  disabled: boolean
): Record<string, EnhancedTableHeader> => ({
  certificateNumber: {
    name: 'certificateNumber',
    title: 'Certificate Number',
    type: EnhancedTableHeaderType.Link,
    openUrlInNewTab: true,
    urlTemplate: '/production/policies/{certificateID}',
    filterField: 'policy.policyNumber'
  },
  insuredName: {
    name: 'insuredName',
    title: 'Insured Name',
    type: EnhancedTableHeaderType.Text,
    filterField: 'policyPerson.person.fullName'
  },
  relation: {
    name: 'relation',
    title: 'Relation',
    type: EnhancedTableHeaderType.Text,
    filterField: 'policyPerson.relation'
  },
  age: {
    name: 'age',
    title: 'Age',
    type: EnhancedTableHeaderType.Text,
    filterField: 'PolicyPerson.Person.DateOfBirth'
  },
  cover: {
    name: 'cover',
    title: 'Cover',
    type: EnhancedTableHeaderType.Text,
    filterField: 'policyPlanCover.cover.code'
  },
  sumInsured: {
    name: 'sumInsured',
    title: 'Sum Insured',
    type: EnhancedTableHeaderType.RoundedCurrency,
    currency,
    disableSort: true
  },
  netPremium: {
    name: 'netPremium',
    title: 'Net Premium',
    type: EnhancedTableHeaderType.RoundedCurrency,
    currency,
    disableSort: true
  },
  netPremiumVariance: {
    name: 'netPremiumVariance',
    title: 'Net Premium Variance',
    type: EnhancedTableHeaderType.Input,
    inputType: EnhancedHeaderInputTypes.RoundedCurrency,
    currency,
    allowNegative: true,
    maxValue: 0,
    disabled,
    disableSort: true
  },
  charges: {
    name: 'charges',
    title: 'Charges',
    type: EnhancedTableHeaderType.RoundedCurrency,
    currency,
    disableSort: true
  },
  chargesVariance: {
    name: 'chargesVariance',
    title: 'Charges Variance',
    type: EnhancedTableHeaderType.Input,
    inputType: EnhancedHeaderInputTypes.RoundedCurrency,
    currency,
    allowNegative: true,
    maxValue: 0,
    disabled,
    disableSort: true
  },
  tpaFees: {
    name: 'tpaFees',
    title: 'TPA Fees',
    type: EnhancedTableHeaderType.RoundedCurrency,
    currency,
    disableSort: true
  },
  tpaFeesVariance: {
    name: 'tpaFeesVariance',
    title: 'TPA Fees Variance',
    type: EnhancedTableHeaderType.Input,
    inputType: EnhancedHeaderInputTypes.RoundedCurrency,
    currency,
    allowNegative: true,
    maxValue: 0,
    disabled,
    disableSort: true
  },
  grossPremium: {
    name: 'grossPremium',
    title: 'Gross Premium',
    type: EnhancedTableHeaderType.RoundedCurrency,
    currency,
    disableSort: true
  },
  grossPremiumVariance: {
    name: 'grossPremiumVariance',
    title: 'Gross Premium Variance',
    type: EnhancedTableHeaderType.RoundedCurrency,
    currency,
    disableSort: true
  },
  totalPremium: {
    name: 'totalPremium',
    title: 'Total Premium',
    type: EnhancedTableHeaderType.RoundedCurrency,
    currency,
    disableSort: true
  },
  totalPremiumVariance: {
    name: 'totalPremiumVariance',
    title: 'Total Premium Variance',
    type: EnhancedTableHeaderType.RoundedCurrency,
    currency,
    disableSort: true
  }
});
